export const FILTER_MENU_TYPES = {
    Checkbox: 'Checkbox',
    Radio: 'Radio',
} as const;

// Z-index for filter menu to be above other elements
export const FILTER_MENU_Z_INDEX = 15;
